import { createContext, useContext, type ReactNode } from "react";
import type { AccountsExperienceState } from "../../application/auth/accounts-experience";
import type { OrganizationId } from "../../shared/identifiers/ids";
export type AccountsExperienceNotice = "AUTH_INITIATION_NOT_CONNECTED";
export type AccountsExperienceContextValue = Readonly<{
  state: AccountsExperienceState;
  notice?: AccountsExperienceNotice;
  startAuthentication(): void;
  selectOrganization(organizationId: OrganizationId): void;
  logout(): Promise<void>;
}>;
const AccountsExperienceContext = createContext<AccountsExperienceContextValue | undefined>(undefined);
export const AccountsExperienceContextProvider = ({ value, children }: { value: AccountsExperienceContextValue; children?: ReactNode }) =>
  <AccountsExperienceContext.Provider value={value}>{children}</AccountsExperienceContext.Provider>;
export const useAccountsExperience = (): AccountsExperienceContextValue => {
  const value = useContext(AccountsExperienceContext);
  if (value === undefined) throw new Error("AccountsExperienceProvider missing");
  return value;
};
